import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ...params }) => {
  return await dponetAPI.get('/tags', { params })
}

const show = async ({ tagId = '', ...params }) => {
  return await dponetAPI.get(`/tags/${tagId}`, { params })
}

const destroy = async (tagId) => {
  return await dponetAPI.delete(`/tags/${tagId}`)
}

export default {
  get,
  show,
  destroy,
}
